export var EFieldType;
(function (EFieldType) {
    EFieldType["BOOL"] = "bool";
    EFieldType["SELECT"] = "select";
    EFieldType["TEXT"] = "text";
    EFieldType["NUMBER"] = "number";
    EFieldType["DATE"] = "date";
})(EFieldType || (EFieldType = {}));
